<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>取消课程记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="5">
          <Col :span="8">
            <Form-item label="上课时间">
              <Row>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="startTimeDateChange" style="width: 100%;"></Date-picker>
                </Col>
                <Col :span="1" style="text-align: center;">-</Col>
                <Col :span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="endTimeDateChange" style="width: 100%;"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col span="4">
            <Form-item label="学生ID">
              <Input name="uid" v-model="queryParam.uid"/>
            </Form-item>
          </Col>
<!--          <Col span="6">-->
<!--            <Form-item label="学导" >-->
<!--              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="queryParam.studyConsultantId"/>-->
<!--            </Form-item>-->
<!--          </Col>-->
        </Row>
        <Row :gutter="12">
          <Col span="4">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search" >搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLesson/opened/cancelList"
      :params="queryParam" :onLoading="onLoading" @on-selection-change="selectionChange"></List>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
  </div>

</template>
<script>
  import ShowImageCarousel from "../order/ShowImageCarousel.vue";
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'

  export default {
    components: {ShowImageCarousel},
    data () {
      return {
        searchLoading: false,
        exportLoading: false,
        passLoading: false,
        reload: 0,
        rankScoreSeq: 0,
        uid: null,
        selectionIds: [],
        showImgModal: false,
        showImgList: [],
        queryParam: {
          uid: null,
          status: null,
          studyConsultantId: null,
          startTime: '',
          endTime: '',
        },
        title: [
          {
            title: '学生信息',
            width: 150,
            fixed: 'left',
            align: 'center',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('p', [h('a', { on: { click: () => this.openInfoModal(row.uid, row.userNickname) } }, row.uid + '-' + row.userNickname)])])
            }
          },
          {
            title: '老师ID/姓名',
            width: 180,
            render: (h, params) => {
              let row = params.row
              let isChange = ''
              if (row.isNewTch === 1) {
                isChange = '(替)'
              }
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchFirstName + ' ' + row.tchLastName + isChange,
                score: row.monthRankScore,
                onClick: () => this.openNewLessonModal(row.tchId, row.tchFirstName + row.tchLastName)
              })
            }
          },
          {
            title: '课程顾问',
            width: 100,
            key: 'adviserNickname',
          },
          {
            title: '学导',
            width: 100,
            key: 'studyAdviserNickname',
          },
          {
            title: '外管',
            width: 100,
            key: 'tchStudyName',
          },
          {
            title: '课程信息',
            width: 130,
            render: (h, params) => {
              let row = params.row
              let lsnType = row.lsnType
              let typeEnum = this.$constant.getEnum(this.$constant.bookLessonOpenedLsnType, lsnType)
              let courseType = row.courseType
              let courseTypeEnum = this.$constant.getEnum(this.$constant.courseType, courseType)
              let cType = courseTypeEnum && courseTypeEnum.text
              if (cType) {
                cType = '课程类别:' + cType
              } else {
                cType = ''
              }
              return h('div', [
                h('p', row.id),
                h('p', row.lessonTitle),
                h('p', {style: {'font-size': '12px', color: 'red'}}, cType),
                h('p', {style: {'font-size': '12px', color: '#2d8cf0'}}, '课程类型:' + (typeEnum && typeEnum.text))])
            }
          },
          {
            title: '补课信息',
            width: 130,
            render: (h, params) => {
              let row = params.row
              if (!row.cancelLogs || !row.cancelLogs.makeUpLesson) {
                return '无'
              }
              let lsnType = row.cancelLogs.makeUpLesson.lsnType
              let typeEnum = this.$constant.getEnum(this.$constant.bookLessonOpenedLsnType, lsnType)
              let courseType = row.cancelLogs.makeUpLesson.courseType
              let courseTypeEnum = this.$constant.getEnum(this.$constant.courseType, courseType)
              let cType = courseTypeEnum && courseTypeEnum.text
              if (cType) {
                cType = '课程类别:' + cType
              } else {
                cType = ''
              }
              return h('div', [
                h('p', row.cancelLogs.makeUpLesson.id),
                h('p', row.cancelLogs.makeUpLesson.lessonTitle),
                h('p', {style: {'font-size': '12px', color: 'red'}}, cType),
                h('p', {style: {'font-size': '12px', color: '#2d8cf0'}}, '课程类型:' + (typeEnum && typeEnum.text))])
            }
          },
          {
            title: '补课时间',
            width: 110,
            render: (h, params) => {
              let row = params.row
              if (row.cancelLogs) {
                return h('span', row.cancelLogs.makeUpTime)
              } else {
                return h('span', '无')
              }
            }
          },
          {
            title: '状态',
            width: 110,
            render: (h, params) => {
              let remark = params.row.remark
              let lsnSelStatus = params.row.lsnSelStatus
              let statusEnum = this.$constant.getEnum(this.$constant.lsnSelStatus, lsnSelStatus)
              return h('div', {style: {'font-size': '14px'}}, [
                h('span', statusEnum && statusEnum.text),
                h('br'),
                h('span', { style: { 'font-size': '13px', color: 'red' } },remark)
              ])
            }
          },
          {
            title: '取消原因',
            width: 120,
            key: 'cancelReason'
          },
          {
            title: '截图',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              if (row.cancelLogs && row.cancelLogs.attachment) {
                return h('a', {on: {click: () => this.viewPic(row)}}, '查看')
              } else {
                return h('span', '')
              }
            }
          },
          {
            title: '操作人',
            width: 120,
            key: 'creatorName',
            render: (h, params) => {
              let row = params.row
              if (row.cancelLogs) {
                return h('span', row.cancelLogs.adminName)
              }
              return h('p', row.adminNickname)
            }
          },
          {
            title: '取消时间',
            width: 110,
            key: 'gmtModified',
          },
          {
            title: '上课时间',
            width: 110,
            render: (h, params) => {
              let lsnBeginTime = params.row.lsnBeginTime
              return h('span', this.$moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
          {
            title: '排课时间',
            width: 110,
            render: (h, params) => {
              let lsnBeginTime = params.row.lessonOpenTime
              return h('span', this.$moment(lsnBeginTime, 'X').format('YYYY-MM-DD HH:mm'))
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      openInfoModal (val) {
        this.uid = val
        let {href} = this.$router.resolve({
          name: 'userPayDetail',
          query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/UserProvisionalList'}
        })
        window.open(href, '_blank')
      },
      openNewLessonModal (k, v) {
        if (this.$appConfig.active === 'prod'){
        window.open('https://bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
        }else {
        window.open('https://develop.bops.kouyujie.cn/#/lesson/timetableDetailList?tchId=' + k + '&tchName=' + v)
        }
      },
      search () {
        this.selectionIds = []
        this.reload = new Date().getTime()
      },
            onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      selectionChange (selection) {
        this.selectionIds = selection
      },
      startTimeDateChange (value) {
        this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      endTimeDateChange (value) {
        this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      viewPic (row) {
        this.showImgList = row.cancelLogs.urls
        this.showImgModal = true
      },
      closeImgModal () {
        this.showImgList = []
        this.showImgModal = false
      },
    }
  }

</script>



// WEBPACK FOOTER //
// CancelLessonRecord.vue?a4a419ec